import React from 'react';
import { ImmunizationsTable } from './ImmunizationsTable';
import { NoItemsFound } from '~/shared/components/NoItemsFound';
import { getImmunizationsOptions, ImmunizationTypeOptions } from '@generated';
import { useSuspenseQuery } from '@tanstack/react-query';
import { QuickAddNew } from '~/shared/QuickAdd';
import { PatientImmunizationFormModal } from './forms/PatientImmunizationFormModal';
import { DeclinedImmunizationsTable } from './DeclinedImmunizationsTable';
import { DeclinedImmunizationFormModal } from './forms/DeclinedImmunizationFormModal';

export function PatientImmunizations({ stayId }: { stayId: string }) {
	const { data: patientImmunizations } = useSuspenseQuery(getImmunizationsOptions(stayId));
	const [selectedQuickAddId, setSelectedQuickAddId] = React.useState<number | null>(null);

	return (
		<div className="space-y-8">
			<div className="col-span-3 mb-4 flex flex-wrap items-center">
				<QuickAddNew options={ImmunizationTypeOptions.filter(x => x.displayForQuickAccess)} onSelect={val => setSelectedQuickAddId(val.id)} />
			</div>
			<div className="mb-4">
				<NoItemsFound
					title="No immunizations recorded"
					subtitle="Click the button below to add an immunization"
					itemCount={patientImmunizations.immunizations.length}
					renderModal={closeModal => <PatientImmunizationFormModal stayId={stayId} closeModal={closeModal} />}
					renderTable={() => <ImmunizationsTable rows={patientImmunizations.immunizations} />}
				/>
			</div>
			<NoItemsFound
				title="No declined immunizations recorded"
				subtitle="Click the button below to add  a declined immunization"
				itemCount={patientImmunizations.declinedImmunizations.length}
				renderModal={closeModal => <DeclinedImmunizationFormModal stayId={stayId} closeModal={closeModal} />}
				renderTable={() => <DeclinedImmunizationsTable rows={patientImmunizations.declinedImmunizations} />}
			/>
			{selectedQuickAddId && (
				<PatientImmunizationFormModal
					stayId={stayId}
					quickAddImmunizationTypeId={selectedQuickAddId}
					closeModal={() => setSelectedQuickAddId(null)}
				/>
			)}
		</div>
	);
}
